export const test = {};

export const initial = {};



/** WEBPACK FOOTER **
 ** ./js/redux/state/editCampaign.state.js
 **/